export default __webpack_public_path__ + "static/media/insta_dexpro2.b7914995.png";